export const fallbackLang = 'zh-TW';
export const languages = [fallbackLang, 'en'];
export const defaultNS = 'default';
export const cookieName = 'i18next';
export const headerName = 'x-i18next-current-language';
